import { Link } from 'react-router-dom';
import ServiceCard from '../components/ServiceCard';
import { Button } from '../components/ui/button';
import FinancingBanner from '../components/FinancingBanner';
import { Wrench, Cog, Gauge, Car, Paintbrush, Zap, Snowflake, Cpu, Settings2, Sun } from 'lucide-react';

export default function Services() {
	const links = [
		{ name: 'Engine', to: '/services/engine', desc: 'Diagnostics, repair, rebuilds at our hubs.', icon: <Wrench size={18} /> },
		{ name: 'Transmission', to: '/services/transmission', desc: 'Rebuilds, replacements, fluid service.', icon: <Cog size={18} /> },
		{ name: 'Suspension', to: '/services/suspension', desc: 'Alignment, struts, control arms.', icon: <Gauge size={18} /> },
		{ name: 'Glass', to: '/services/glass', desc: 'Repair & replacement with ADAS calibrations.', icon: <Car size={18} /> },
		{ name: 'Body', to: '/services/body', desc: 'Dent repair, panels, refinish quality control.', icon: <Paintbrush size={18} /> },
		{ name: 'Electrical', to: '/services/electrical', desc: 'CAN diagnostics, modules, sensors, harness.', icon: <Zap size={18} /> },
		{ name: 'A/C', to: '/services/ac', desc: 'Leak tests, recharge, compressors & condensers.', icon: <Snowflake size={18} /> },
		{ name: 'Programming & Tuning', to: '/services/programming', desc: 'OEM coding, reflashes, key programming.', icon: <Cpu size={18} /> },
		{ name: 'Aftermarket Mods', to: '/services/aftermarket', desc: 'Lifts, wheels/tires, exhaust, audio & lights.', icon: <Settings2 size={18} /> },
		{ name: 'Tint', to: '/services/tint', desc: 'Premium films, UV/heat rejection, lifetime work.', icon: <Sun size={18} /> },
	];

	return (
		<div>
			<section className="bg-gradient-to-b from-white to-babyblue/20 border-b">
				<div className="container py-12 md:py-16">
					<h1 className="text-3xl md:text-4xl font-extrabold text-gradient">On‑Demand Automotive Services</h1>
					<p className="mt-3 max-w-3xl text-gray-600">Choose mobile service for light work or route complex jobs to our centralized hubs. AI optimizes diagnostics, parts, technicians and scheduling to minimize downtime and cost while maximizing quality.</p>
					<div className="mt-6 flex gap-3">
						<a href="https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5" target="_blank" rel="noreferrer"><Button variant="gradient">Get Started</Button></a>
						<Link to="/contact"><Button variant="outline">Talk to Sales</Button></Link>
					</div>
				</div>
			</section>

			<FinancingBanner />

			<section className="container py-10 md:py-14">
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
					{links.map((l) => (
						<Link key={l.to} to={l.to} className="block">
							<ServiceCard title={l.name} description={l.desc} icon={l.icon} />
						</Link>
					))}
				</div>
			</section>

			<FinancingBanner />

			<section className="bg-white border-t">
				<div className="container py-12 md:py-16 grid md:grid-cols-3 gap-8">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="text-lg font-semibold">Mobile Service</h3>
						<p className="mt-2 text-gray-600">Light work performed at your home or office with fully-equipped vehicles.</p>
						<ul className="mt-3 list-disc list-inside text-gray-700 space-y-1">
							<li>Glass repair, diagnostics, minor installs</li>
							<li>Same-day appointments in many areas</li>
							<li>Live tracking and status updates</li>
						</ul>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="text-lg font-semibold">Hub Service</h3>
						<p className="mt-2 text-gray-600">Major repairs executed in Ubiquity hubs with factory-level tooling and QA.</p>
						<ul className="mt-3 list-disc list-inside text-gray-700 space-y-1">
							<li>Engine/transmission, body & paint, calibrations</li>
							<li>Parts procurement and cost optimization</li>
							<li>Faster cycle time and warranty coverage</li>
						</ul>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="text-lg font-semibold">Why Ubiquity</h3>
						<p className="mt-2 text-gray-600">Automation, transparency and safety at every step.</p>
						<ul className="mt-3 list-disc list-inside text-gray-700 space-y-1">
							<li>Instant estimates and clear ETAs</li>
							<li>OEM-aligned procedures and documentation</li>
							<li>Lifetime workmanship warranty</li>
						</ul>
					</div>
				</div>
			</section>

			<section className="bg-gradient-to-r from-babyblue via-royalpurple to-orangepeel">
				<div className="container py-12 md:py-16 text-white">
					<h3 className="text-2xl font-bold">Ready to schedule?</h3>
					<p className="mt-2 max-w-2xl">Get a fast, accurate estimate and book in minutes. Our AI handles the rest.</p>
					<div className="mt-6 flex gap-3">
						<a href="https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5" target="_blank" rel="noreferrer"><Button className="bg-white text-secondary hover:opacity-90">Start Now</Button></a>
						<Link to="/contact"><Button variant="outline" className="border-white text-white hover:bg-white/10">Contact Sales</Button></Link>
					</div>
				</div>
			</section>
		</div>
	);
}
